import { useCdnAssets } from "#hooks/useCdnAssets.ts";
import type { Asset } from "#types/assets.ts";
import { Image, type ImageProps } from "@hopper-ui/components";

interface Props extends ImageProps {
    asset: Asset;
}

export const CdnAsset = ({ asset, ...rest }: Props) => {
    const { getCdnAssetUrl } = useCdnAssets();

    return (
        <Image
            src={getCdnAssetUrl(asset)}
            {...rest}
        />
    );
};
